import Vue from 'vue'
import Component from 'vue-class-component'
import { Operations, DataEntity } from '@/entity/warehouse/Operations/Operations.types'
import { OperationsStore } from '@/store/modules/Warehouse/Operations'

@Component
export class OperationsMix extends  Vue {
    get operations(): Operations | null {
        return  OperationsStore.operations
    }
    get operation(): DataEntity | null {
        return  OperationsStore.operation
    }
}
